export default {
  loadingUserRequests: (state, loading) => {
    state.loadingRequest = loading
  },
  setUserRequests: (state, data) => {
    state.onboardingRequests = data
  },
  setRestrictedRegions(state, regions) {
    state.updateAccount.restrictedRegions = regions
  },
  showCloneAccountDialog: (state, account) => {
    console.log('----------- showCloneAccountDialog -----------')
    console.log(account)
    console.log('----------------------------------------------')
    state.cloneRecord.cloneDialog = true
    state.cloneRecord.awsOnboarding = {
      Acct_name: account.Acct_name
    }
  }, 
  addClone: (state, data) => {
    console.log('------ addClone -------')
    console.log(data)
    console.log('-----------------------')
    state.cloneRecord.addForm = data.addFormStatus
    state.cloneRecord.acctName = data.accountname
    state.cloneRecord.purpose = data.purpose
    state.cloneRecord.countrycode = data.countrycode
    state.cloneRecord.view = data.viewFormStatus
 
    
  },
  addOnboardingClone: (state, data) => {
    state.cloneRecord.addForm = false
    state.cloneRecord.addMessage = data.message
    state.cloneRecord.bulkRecords.push(data.record)
    console.log('------- addOnboardingClone -------')
    console.log(data)
    console.log(data.message)
    console.log(state.cloneRecord.bulkRecords)
    console.log('---------------------------------')
  },
  showUpdateDialog: (state, account) => {
    if(account.SaaS === 'No'){
      account.SaaS_Solution =''
    }

    console.log('----------- showUpdateDialog ---------')
    console.log(account)
    console.log('--------------------------------------')

    state.updateAccount.fields = {
      Onboarding_Id: account.Onboarding_Id,
      Project_Id: account.Project_Id,
      OppReg_Id: account.OppReg_Id,
      Acct_ID: account.Acct_ID,
      Acct_name: account.Acct_name,
      Acct_DL: account.Acct_DL,
      Requestor_Id: account.Requestor_Id,
      Requestor_FullName: account.Requestor_FullName,
      Contact_Id: account.Contact_Id,
      Client_Shortname: account.Client_Shortname,
      Cust_Shortname: account.Cust_Shortname,
      Contact_FullName: account.Contact_FullName,
      WBS_code: account.WBS_code,
      IWO_Code: account.IWO_Code,
      AWS_credits: account.AWS_credits,
      Account_Owners: account.Account_Owners,
      Financial_Id: account.Financial_Id,
      IAM_Users: account.IAM_Users,
      Notification_List: account.Notification_List,
      CLoudCheckr_users: account.CLoudCheckr_users,
      Financial_Owner: account.Financial_Owner,
      Invoice_DL: account.Invoice_DL,
      AWS_Support_Type: account.AWS_Support_Type,
      SaaS_Solution: account.SaaS_Solution,
      Acct_Description: account.Acct_Description,
      Specific_Region: account.Specific_Region,
      Specific_Location: account.Specific_Location,
      Account_Purpose: account.Account_Purpose,
      Managed_Svc: account.Managed_Svc,
      SaaS: account.SaaS,
      Onboarding_Status: account.Onboarding_Status,
      Date_Requested: account.Date_Requested,
      Restricted_Region_Id: account.Restricted_Region_Id,
      Request_Type: account.Request_Type,
      Business_Use: account.Business_Use,
      OBS_Date_Updated: account.OBS_Date_Updated,
      Engr_Assigned_To: account.Engr_Assigned_To,
      Customer_Regulations: account.Customer_Regulations,
      AWS_Req_Type: account.AWS_Req_Type,
      MP_ID: account.MP_ID,
      GovCloud_Resource_Account: account.GovCloud_Resource_Account
    }

    let purposeObj = JSON.parse(state.updateAccount.fields.Account_Purpose);
    let custRegObj = JSON.parse(state.updateAccount.fields.Customer_Regulations)
    let accountOwners = JSON.parse(state.updateAccount.fields.Account_Owners)
    // let cloudCheckrUsers = JSON.parse(state.updateAccount.fields.CLoudCheckr_users)
    let NotificationList = JSON.parse(state.updateAccount.fields.Notification_List)
    let iamUsers = JSON.parse(state.updateAccount.fields.IAM_Users)
    let invoiceOwners = state.updateAccount.fields.Invoice_DL !== 'None' ? JSON.parse(state.updateAccount.fields.Invoice_DL) : []

    let financialOwners
    if(state.updateAccount.fields.Financial_Owner !== 'None'){
      financialOwners = JSON.parse(state.updateAccount.fields.Financial_Owner)
    } else {
      financialOwners = []
    }

    state.updateAccount.showDialog = true

    state.updateAccount.record.financial = {
      isAwsCredits: true,
      Financial_Id: account.Financial_Id,
      wbsCode: account.WBS_code,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: account.IWO_Code,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false,
      savedForLater: false,
      isPromoCode: null,
      awsCredits: account.AWS_credits
    }

    state.updateAccount.awsOnboarding = {
      isSaas: true,
      isSpecificRegion: true,
      isSpecificLocation: true,
      isCustomerRegulations: true,

      Acct_name: account.Acct_name,
      Specific_Region: account.Specific_Region,
      SaaS_Solution: account.SaaS_Solution,
      Client_Shortname: account.Client_Shortname,
      Cust_Shortname: account.Cust_Shortname,
      Restricted_Region_Id: account.Restricted_Region_Id,
      Specific_Location: account.Specific_Location,
      Customer_Regulations: custRegObj,
      Acct_Description: account.Acct_Description,
      GovCloud_Resource_Account: account.GovCloud_Resource_Account,
      AWS_Purpose: {
        all: purposeObj.all,
        poc: {
          q1: purposeObj.poc.q1,
          q2: purposeObj.poc.q2,
          q3: purposeObj.poc.q3,
          q4: purposeObj.poc.q2,
          q5: null
        }
      },

      Managed_Svc: account.Managed_Svc,
      AWS_Support_Type: account.AWS_Support_Type
    }

    state.updateAccount.awsAccountContact = {
      acctOwner: {
        name: null,
        phone: null,
        email: null
      },
      submitting: false,
      submitted: false,
      contactStatus: false,
      contactStatusMsg: null,
      Account_Owners: accountOwners,

      IAM_Users: iamUsers,
      Notification_List: NotificationList,
      Financial_Owner: financialOwners,
      Invoice_DL: invoiceOwners
    }

    if (account.AWS_credits === '') { state.updateAccount.record.financial.isAwsCredits = false }

    if (account.SaaS !== 'Yes') { state.updateAccount.awsOnboarding.isSaas = false }

    if (account.Restricted_Region_Id === 'None' || account.Restricted_Region_Id === '') {
      state.updateAccount.awsOnboarding.isSpecificRegion = false
    }

    if (account.Specific_Location === 'None' || account.Specific_Location === '') {
      state.updateAccount.awsOnboarding.isSpecificLocation = false
      state.updateAccount.awsOnboarding.Specific_Location = ''
    }
    if (custRegObj.length <= 0) {
      state.updateAccount.awsOnboarding.isSpecificLocation = false
    }
  },
  resetWbsValidation(state) {
    state.updateAccount.record.financial = {
      ...state.updateAccount.record.financial,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false
    }
  },
  setWbsCodeValidating(state, loading) {
    state.updateAccount.record.financial = {
      ...state.updateAccount.record.financial,
      wbsValidating: loading
    }
  
  },
  setWbsValidationResponse(state, response) {
    if (response.valid) {
      state.updateAccount.record.financial = {
        ...state.updateAccount.record.financial,
        wbsCodeValidated: true,
        wbsValidationMessage: response.message,
        wbsType: response.type
      }
    } else {
      state.updateAccount.record.financial = {
        ...state.updateAccount.record.financial,
        wbsCodeValidated: false,
        wbsType: '',
        wbsValidationMessage: response.message
      }
    }
  },

  setIwoCodeValidating(state, loading) {
    state.updateAccount.record.financial = {
      ...state.updateAccount.record.financial,
      iwoValidating: loading
    }
  },
  setIwoValidationResponse(state, response) {
    if (response.valid) {
      state.updateAccount.record.financial = {
        ...state.updateAccount.record.financial,
        iwoCodeValidated: true,
        iwoValidationMessage: response.message
      }
    } else {
      state.updateAccount.record.financial = {
        ...state.updateAccount.record.financial,
        iwoCodeValidated: false,
        iwoValidationMessage: response.message
      }
    }
  },

  loadingUpdateAwsReq(state, saving) {
    state.updateAccount.saving = saving
  },
  updateAccountRecord(state, account) {

    let custRegulations = account.awsOnboarding.Customer_Regulations ? JSON.stringify(account.awsOnboarding.Customer_Regulations) : "[]";
    let iAmUsers = account.awsAccountContact.IAM_Users ? JSON.stringify(account.awsAccountContact.IAM_Users) : "[]"
    let financialOwners = account.awsAccountContact.Financial_Owner ? JSON.stringify(account.awsAccountContact.Financial_Owner) : "[]"
    let invoiceOwners = account.awsAccountContact.Invoice_DL ? JSON.stringify(account.awsAccountContact.Invoice_DL) : "[]"

    state.updateAccount.fields = {
      ...state.updateAccount.fields,
      Acct_name: account.awsOnboarding.Acct_name,
      Client_Shortname: account.awsOnboarding.Client_Shortname,
      WBS_code: account.record.financial.wbsCode,
      IWO_Code: account.record.financial.iwoCode,
      AWS_credits: account.record.financial.awsCredits,
      Invoice_DL: invoiceOwners,
      AWS_Support_Type: account.awsOnboarding.AWS_Support_Type,
      SaaS_Solution: account.awsOnboarding.SaaS_Solution,
      Acct_Description: account.awsOnboarding.Acct_Description,
      Specific_Region: account.awsOnboarding.Specific_Region,
      Specific_Location: account.awsOnboarding.Specific_Location,
      Account_Purpose: account.awsOnboarding.Account_Purpose,
      Managed_Svc: account.awsOnboarding.Managed_Svc,
      SaaS: account.awsOnboarding.SaaS,
      Restricted_Region_Id: account.awsOnboarding.Restricted_Region_Id,
      Customer_Regulations: custRegulations,
      GovCloud_Resource_Account: account.awsOnboarding.GovCloud_Resource_Account
      
    }
  },
  updateOnboardingContacts(state, contacts) {
    state.updateAccount.fields.Notification_List = state.updateAccount.awsAccountContact.Notification_List ? JSON.stringify(state.updateAccount.awsAccountContact.Notification_List.map(record => record)) : '[]'
    state.updateAccount.fields.IAM_Users = state.updateAccount.awsAccountContact.IAM_Users ? JSON.stringify(state.updateAccount.awsAccountContact.IAM_Users.map(record => record)) : '[]'
    state.updateAccount.fields.Financial_Owner = state.updateAccount.awsAccountContact.Financial_Owner ? JSON.stringify(state.updateAccount.awsAccountContact.Financial_Owner.map(record => record)) : '[]'
  },
  updateViewMyRequestList(state, account) {
    let updatedRecordIndex = state.onboardingRequests.findIndex(record => record.Onboarding_Id === account.Onboarding_Id)
    if (updatedRecordIndex !== -1) {
      state.onboardingRequests.splice(updatedRecordIndex, 1, { ...account })
    }

  },


  cloneAccountDialog(state,account){
    console.log('------- clone account dialog -------')
    console.log(account)
    console.log('------------------------------------')
  }

}
